




import { Component, Vue } from 'vue-property-decorator';

import LocaleSelect from '@/components/common/LocaleSelect.vue';

@Component({
  components: { LocaleSelect },
})
export default class LocaleSelectSolo extends Vue {}
